import Home from './ui/pages/Home';
import BackgroundLayer from './ui/components/utils/BackgroundLayer';
import { SessionProvider } from './core/context/SessionContext';
import { DataProvider } from './core/context/DataContext';
import DataLoader from './ui/components/DataLoader';
import { useLayoutMode } from './core/hooks/useLayoutMode';

function App() {
  const params = new URLSearchParams(window.location.search);
  const boxId = params.get('box_id') ?? '2';
  const layoutMode = useLayoutMode();

  return (
    <div className={layoutMode === 'desktop' ? 'desktop-layout' : 'mobile-layout'}>
      <DataProvider boxId={Number(boxId)}>
        <SessionProvider initialSessionId={boxId}>
          <BackgroundLayer>
            <DataLoader />
            <Home />
          </BackgroundLayer>
        </SessionProvider>
      </DataProvider>
    </div>
  );
}

export default App;
